import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../../common/context/ApplicationPropertiesProvider";

export const UnconfirmedSubscriptionControllerContext = createContext();

export const ACTIONS = {
  SET_JSON_FORM: "SET_JSON_FORM",
  SET_DATA_TABLE: "SET_DATA_TABLE" 
};

const initialState = {
  jsonForm:null
};

const UnconfirmedSubscriptionControllerReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_JSON_FORM: {
      return {
          ...state,
          jsonForm: action.payload,
          };
    }
    case ACTIONS.SET_DATA_TABLE: {
      return {
          ...state,
          dataTable: action.payload,
          };
    }
    default: {
      return state;
    }
  }
};
const UnconfirmedSubscriptionControllerContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(UnconfirmedSubscriptionControllerReducer, initialState);

  useEffect(() => {
    if(state.jsonForm){
        LiferayService.getUnconfirmedSubscription(properties.base_url_api,state.jsonForm)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_DATA_TABLE,
          });
        })
      }
  }, [state.jsonForm]);

  
  return (
    <UnconfirmedSubscriptionControllerContext.Provider value={[state, dispatch]}>
      {children}
    </UnconfirmedSubscriptionControllerContext.Provider>
  );
};
export default UnconfirmedSubscriptionControllerContextProvider;